import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const uploadIcon = svgToTinyDataUri(
  `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 12V3M8 3L4 7M8 3L12 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2 14H14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>`
);
